export class DotCMSIdChecker {
  public isDotCMSId(id: string): boolean {
    // dotCMS Ids are guids, liferay uses ints (sometimes represented as strings)
    const parsedValue = Number(id);
    // If it is a guid, 'parseInt()' will result in NaN
    return Number.isNaN(parsedValue);
  }
}
